module.exports = __webpack_public_path__ + "static/media/SplashBkg.b4fa8a70.png";